module.exports = __webpack_public_path__ + "static/media/shadow-00.5a0fe66f.png";